import React from 'react';
import mainTpl from '../templates/main';
import GreenCardsModel from '../../Cards/models/greenCards.m';
import {apiback} from '../../../config';
import BaseNewCardView from '../../Cards/views/BaseNewCardView';
import {canUseDOM} from '../../../helpers/canUseDOM';

export default class extends BaseNewCardView {
    template = mainTpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            ui: this.uiStates.INITIAL,
            model: {},
            isUtm: new URLSearchParams(this.props.location.search).get('utm_source'),
            tab: 'tariffs'
        };
    }

    componentWillMount() {
        super.componentWillMount();
        if (!canUseDOM) return;
        fetch(apiback('CREDIT_CARDS'))
            .then(res => res.json())
            .then(json =>
                this.setState({
                    model: new GreenCardsModel(json.data['green_card'])
                })
            );
    }

    static displayName = 'GreenCard.Views.Main';
}
